<div class="button-wrap">
    <div class="button-actions">
        <button
            i18n
            *ngIf="enabledActions[SupervisorAction.VoidGame]"
            [disabled]="hasSecurityDoorsOpen || appPhase === AppPhase.WaitingForCroupier || appPhase === AppPhase.ShoeChange"
            class="button roulete-button-mini button-neutral"
            (click)="actionClicked.emit(SupervisorAction.VoidGame)"
        >
            Void game
        </button>

        <!-- <button
            i18n
            *ngIf="enabledActions[SupervisorAction.ChangeResult]"
            [disabled]="appPhase !== AppPhase.DealingCards"
            class="button roulete-button-mini button-neutral"
            (click)="actionClicked.emit(SupervisorAction.ChangeResult)"
        >
            Change result
        </button> -->
    </div>

    <div class="button-actions">
        <button
            i18n
            *ngIf="enabledActions[SupervisorAction.CloseTable]"
            [disabled]="hasSecurityDoorsOpen || flagsState.tableClosingRequested"
            class="button roulete-button-mini button-danger"
            [class.button-highlight]="flagsState.tableClosingRequested"
            (click)="actionClicked.emit(SupervisorAction.CloseTable)"
        >
            Close table
        </button>

        <button
            i18n
            *ngIf="enabledActions[SupervisorAction.ContinueGame]"
            [disabled]="hasSecurityDoorsOpen"
            class="button roulete-button-mini button-accent"
            (click)="actionClicked.emit(SupervisorAction.ContinueGame)"
        >
            Continue Game
        </button>
    </div>
</div>
